module.exports = __webpack_public_path__ + "img/multi-store-data-combination.95d56503.svg";